// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RedEnvelopeTwoToneSvg from "@fishx/icons-svg/es/asn/RedEnvelopeTwoTone";
import FishxIcon from '../components/FishxIcon';

var RedEnvelopeTwoTone = function RedEnvelopeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RedEnvelopeTwoToneSvg
  }));
};

RedEnvelopeTwoTone.displayName = 'RedEnvelopeTwoTone';
export default React.forwardRef(RedEnvelopeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RedEnvelopeTwoTone.js
// module id = 3988
// module chunks = 0